module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_cuadrada_marco_comida_47.ecd00064.png";